import Alert from "~/ui-rtk/components/ui/common/Alert"
import Card from "~/ui-rtk/components/ui/common/Card"
import { H4, P } from "~/ui-rtk/components/ui/typography"
import useDate from "~/ui-rtk/hooks/date"
import { isPeriodAfterLatestAnalyzedDate } from "../../utils/analyzed-mentions-period"

const dayjs = useDate()

/** Replaces the dashboard body when the brand has no analyzed mentions at all. */
export function NoAnalyzedMentionsState() {
  return (
    <Card
      rounded
      className="bg-system-blue-800 rounded-system-md p-system-lg mt-system-md"
      role="status"
    >
      <H4>No analyzed mentions yet</H4>
      <P className="text-basic-white/60 mt-system-xs">
        Mentions Analysis is built from Instagram and TikTok mentions that have
        been run through AI theme and sentiment analysis. None are available for
        this brand yet, so there is nothing to chart or export.
      </P>
    </Card>
  )
}

/**
 * Warns when the selected period starts after the latest analyzed mention, the
 * one case the date picker's ceiling cannot prevent (a period carried in the
 * URL). Every widget below would otherwise just render empty.
 */
export function PeriodAfterLatestMentionAlert({
  dateRange,
  latestDate,
}: {
  dateRange: [Date, Date]
  latestDate?: Date
}) {
  if (!isPeriodAfterLatestAnalyzedDate(dateRange, latestDate)) {
    return null
  }
  return (
    <div className="mt-system-md w-full" role="status">
      <Alert
        variant="warning"
        injectable={false}
        title="No analyzed mentions in this period"
        content={`The most recent analyzed mention is from ${dayjs(
          latestDate,
        ).format(
          "MMM D, YYYY",
        )}. Choose a period that ends on or before that date.`}
      />
    </div>
  )
}
